











































import { Component, Vue, Prop, Mixins, Ref } from 'vue-property-decorator';
import cell from '../cell.vue';
@Component({
	components: {
		cell,
	},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public displayFieldConfig!: any;
	@Prop({ default: () => [] }) public displayField!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	@Prop({ default: () => [] }) public select!: any;
	@Prop({ default: '' }) public titleField!: string;
	@Prop({ default: false }) public isHiddenCheckBtn!: boolean;
	private get displayFieldShow() {
		const exclude = ['richText', 'remark', 'cuttingLine', 'associationTable', 'accessory'];
		return this.displayField.filter((item) => !exclude.includes(item.fieldType)).slice(0, 4);
	}
}
